import {
  getPreviewDirectInquiryColor,
  getPreviewIndirectInquiryColor,
} from "~/providers/utils/getPreviewInquiryColor";
import {
  DirectInquiry,
  IndirectInquiry,
} from "~/providers/utils/types/patientIntakePreviewTypes";
import { RenderDirectQuestions } from "../RenderDirectQuestions";
import { RenderIndirectQuestions } from "../RenderIndirectQuestions";
import { InquiriesLayout } from "./InquiriesLayout";

interface InquiriesProps {
  directInquiry: DirectInquiry;
  indirectInquiry: IndirectInquiry;
}

export const Inquiries = ({
  directInquiry,
  indirectInquiry,
}: InquiriesProps) => (
  <div className="flex gap-3">
    <InquiriesLayout
      title="Direct inquiry"
      classification={directInquiry.classification}
      classificationClassName={getPreviewDirectInquiryColor(
        directInquiry.classification,
      )}
    >
      <RenderDirectQuestions directInquiryQuestions={directInquiry.questions} />
    </InquiriesLayout>
    <InquiriesLayout
      title="Indirect inquiry"
      classification={indirectInquiry.classification}
      classificationClassName={getPreviewIndirectInquiryColor(
        indirectInquiry.classification,
      )}
    >
      <RenderIndirectQuestions indirectSentences={indirectInquiry.sentences} />
    </InquiriesLayout>
  </div>
);
